import { useLocation } from 'react-router';
import { useFlags } from 'src/feature-flags/FlagsHook';

const FAMILY_PATH_PATTERN = /^\/family\/([^/]+)/;
const CLIENT_PATH_PATTERN = /^\/client\/([^/]+)/;

// Siesta renders above the routed <Outlet/>, so it reads the route from useLocation (useParams is
// empty here). On the family screen ?member= only focuses a member's panel — still a household view.
export function useCurrentFamilyContext() {
  const { pathname } = useLocation();
  const { flagEnabledFamilyScreenRework } = useFlags();

  const householdFamilyId = pathname.match(FAMILY_PATH_PATTERN)?.[1] ?? null;
  const clientId = pathname.match(CLIENT_PATH_PATTERN)?.[1] ?? null;
  const isHouseholdView = householdFamilyId !== null;

  return {
    flagEnabled: flagEnabledFamilyScreenRework,
    clientId,
    householdFamilyId,
    isHouseholdView,
  };
}
